import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbShopify: BowlBlock = withIntegration(options.slug.llmKbShopify, [
  {
    name: 'shopName',
    type: 'withText',
    required: true,
  },
  {
    name: 'accessToken',
    type: 'withText',
    required: true,
  },
  {
    name: 'graphqlQuery',
    type: 'json',
    required: true,
  },
  {
    name: 'filterHandle',
    type: 'text',
    hasMany: true,
  },
]);
